var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4353 3.6575L1.93526 42.6575C1.20776 44.165 1.83776 45.9763 3.34151 46.7038C3.74651 46.8988 4.18526 47.0038 4.63526 47.0075H43.6353C45.3078 46.9925 46.654 45.6238 46.639 43.9513C46.6342 43.5029 46.5305 43.0611 46.3353 42.6575L26.8353 3.6575C26.5829 3.15803 26.1969 2.73835 25.7202 2.44514C25.2435 2.15194 24.6949 1.9967 24.1353 1.9967C23.5756 1.9967 23.027 2.15194 22.5503 2.44514C22.0736 2.73835 21.6877 3.15803 21.4353 3.6575Z",
    fill: "#F2A600"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0848 6.395L1.78478 42.92C1.09853 44.3337 1.69103 46.0362 3.10478 46.7225C3.47603 46.9025 3.88478 47 4.29728 47.0075H40.8598C41.2316 47.0041 41.5991 46.9274 41.9413 46.782C42.2835 46.6365 42.5937 46.4251 42.8541 46.1597C43.1146 45.8944 43.3202 45.5803 43.4593 45.2355C43.5984 44.8907 43.6682 44.5218 43.6648 44.15C43.6605 43.7233 43.5606 43.3029 43.3723 42.92L25.1098 6.395C24.7881 5.729 24.2153 5.21788 23.5171 4.9739C22.8189 4.72992 22.0525 4.77303 21.386 5.09375C20.8184 5.36892 20.36 5.82733 20.0848 6.395Z",
    fill: "#FFCC32"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M24.1353 13.2575C25.8603 13.2575 27.2478 14.645 27.1353 16.2575L25.8603 34.2575C25.7178 35.21 24.8328 35.87 23.8803 35.7275C23.5098 35.673 23.1668 35.5006 22.902 35.2358C22.6372 34.971 22.4648 34.628 22.4103 34.2575L21.1353 16.2575C21.0228 14.645 22.4103 13.2575 24.1353 13.2575ZM24.1353 37.2575C25.3765 37.2575 26.3853 38.2663 26.3853 39.5075C26.3853 40.7488 25.3765 41.7575 24.1353 41.7575C22.894 41.7575 21.8853 40.7488 21.8853 39.5075C21.8853 38.2663 22.894 37.2575 24.1353 37.2575Z",
    fill: "#424242"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1353 13.2575C25.8603 13.2575 27.2478 14.645 27.1353 16.2575L25.8603 34.2575C25.7178 35.21 24.8328 35.87 23.8803 35.7275C23.5098 35.673 23.1668 35.5006 22.902 35.2358C22.6372 34.971 22.4648 34.628 22.4103 34.2575L21.1353 16.2575C21.0228 14.645 22.4103 13.2575 24.1353 13.2575Z",
    fill: "url(#paint0_linear_3_13100)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1348 41.7575C25.3774 41.7575 26.3848 40.7501 26.3848 39.5075C26.3848 38.2649 25.3774 37.2575 24.1348 37.2575C22.8921 37.2575 21.8848 38.2649 21.8848 39.5075C21.8848 40.7501 22.8921 41.7575 24.1348 41.7575Z",
    fill: "url(#paint1_linear_3_13100)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.0853 9.1325C19.6353 9.695 12.0603 24.5075 12.0603 24.5075C12.0603 24.5075 11.3853 25.6325 12.3228 26.27C13.1853 26.87 13.9728 26.1575 14.3103 25.595C14.6478 25.0325 21.5103 11.7575 21.7728 11.12C21.9978 10.4187 21.8403 9.65375 21.3603 9.095C20.8728 8.645 20.3853 8.72 20.0853 9.1325Z",
    fill: "#FFF170"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.76 29.9862C12.4434 29.9862 12.9975 29.4322 12.9975 28.7487C12.9975 28.0653 12.4434 27.5112 11.76 27.5112C11.0765 27.5112 10.5225 28.0653 10.5225 28.7487C10.5225 29.4322 11.0765 29.9862 11.76 29.9862Z",
    fill: "#FFF170"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_13100",
    x1: 24.1353,
    y1: 12.6013,
    x2: 24.1353,
    y2: 42.11,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3_13100",
    x1: 24.1348,
    y1: 14.0938,
    x2: 24.1348,
    y2: 43.6025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#424242"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#212121"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.ac2933213f70b2f431443df10b442a13.svg";
export { ForwardRef as ReactComponent };